import ActiveKeys from './active-keys.vue.js';
import RevokedKeys from './revoked-keys.vue.js';

var script = {
  name: 'PendoKeyRotation',
  components: {
    RevokedKeys,
    ActiveKeys
  },
  props: {
    keyIdPrefix: {
      type: String,
      default: ''
    },
    app: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    keys: {
      type: Array,
      required: true
    }
  },
  computed: {
    activeKeys() {
      if (!this.keys) {
        return null;
      }
      return this.keys.filter(key => !key.revoked);
    },
    revokedKeys() {
      if (!this.keys) {
        return null;
      }
      return this.keys.filter(key => key.revoked);
    },
    newKeyName() {
      return `${this.keyIdPrefix}-XXXXX`;
    }
  },
  methods: {
    handleKeyStateChange(method, options) {
      this.$emit(method, options);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-key-rotation.vue2.js.map
